var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.model.containerCss },
    [
      _vm.model.isMobile
        ? _c(
            "div",
            {
              directives: [{ name: "key2click", rawName: "v-key2click" }],
              on: { click: _vm.model.togglePopup },
            },
            [
              _c("sv-svg-icon", {
                attrs: { iconName: _vm.model.icon, size: 24 },
              }),
              _vm._v(" "),
              _c("sv-popup", { attrs: { model: _vm.model.popupModel } }),
            ],
            1
          )
        : _c("sv-list", { attrs: { model: _vm.model.listModel } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }